var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget__mask",style:(("background: rgba(0, 0, 0, " + _vm.maskOpacity + ")")),on:{"click":_vm.triggerClick,"touchmove":function($event){$event.preventDefault();}}})}
var staticRenderFns = []

export { render, staticRenderFns }